import Container from "@client/content/Containers/container";
import TableView from "@client/content/controls/TableView/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { Status } from "@client/types";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import InvoiceModal from "./DetailModal/container";
import "./style.less";
import { type MemberRecurringOrders } from "./types";

export type MapProps = RootContainerProps & {
  items: MemberRecurringOrders.Item[];
  status: string;
};

export interface ActionProps {
  onItemClick: (item: MemberRecurringOrders.Item) => void;
}

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  return (
    <Container {...getContainerProps(props)}>
      <TableView
        {...getRootContainerProps(props)}
        idKey="id"
        isLoading={props.status === Status.Loading}
        columns={[
          { key: "number", name: i18n.originalOrder, dataType: "number" },
          { key: "nextRepeatDate", name: i18n.nextRun, dataType: "date" },
          { key: "productName", name: i18n.product, dataType: "string" },
          { key: "productVariantName", name: i18n.variant, dataType: "string" },
          { key: "statusName", name: i18n.status, dataType: "string" }
        ]}
        data={props.items}
        noDataText={i18n.infoNoSubscriptions}
        onRowClick={props.onItemClick}
        itemMenu={null}
      />

      <InvoiceModal {...getRootContainerProps(props)} />
    </Container>
  );
};
